'use strict';
/**
 * @ngdoc function
 * @name formDesignerApp.controller:fdHelpDialogCtrl
 * @description
 * # fdHelpDialogCtrl
 * Controller of the help dialog
 */

import * as angular from "angular";

angular.module('formApp').controller('fdHelpDialogCtrl', [
  '$scope',
  function ($scope) {
    $scope.init = function () {
      if (!$scope.helpDialog) {
        $scope.helpDialog = {};
      }
    };

    $scope.init();
  }
]);
